// Module
var code = `<div> <img style="width:76px" src="{{imgSrc}}"/> </div>`;
// Exports
export default code;